import React from "react"
import PropTypes from "prop-types"
import { Box } from "rebass"

import RowHeaderComponent from "./RowHeaderComponent"
import RowIntroComponent from "./RowIntroComponent"
import RowTextComponent from "./RowTextComponent"
import RowCardsComponent from "./RowCardsComponent"
import RowImagesComponent from "./RowImagesComponent"
import RowTabsComponent from "./RowTabsComponent"
import RowSlidesComponent from "./RowSlidesComponent"
import RowFaqsComponent from "./RowFaqsComponent"
import RowFormComponent from "./RowFormComponent"
import RowFooterComponent from "./RowFooterComponent"

export const ROW_TYPES = {
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowHeader: RowHeaderComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowIntro: RowIntroComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowText: RowTextComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowCards: RowCardsComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowImages: RowImagesComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowTabs: RowTabsComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowSlides: RowSlidesComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowFaqs: RowFaqsComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowForm: RowFormComponent,
  WPGraphQL_Page_PageBuilder_PageBuilderRows_PbRowFooter: RowFooterComponent,
}

const generateID = (typename, index) => {
  const parts = typename.split("_")
  return `${parts[parts.length - 1]}_${index}`
}

const PageBuilderRows = ({ data }) => {
  const { pageBuilderRows } = data

  return (
    <Box>
      {pageBuilderRows.map((row, index) => {
        const { __typename } = row
        const ComponentType = ROW_TYPES[__typename]

        // append rowID to row data
        row.rowID = generateID(__typename, index);

        return ComponentType ? (
          <ComponentType key={index} data={row} />
        ) : (
          <Box key={index} as="pre" p="2" bg="red" color="white">
            {__typename} not implemented !
          </Box>
        )
      })}
    </Box>
  )
}

PageBuilderRows.propTypes = {
  data: PropTypes.object,
}

export default PageBuilderRows
